<template>
  <div class="award-select">
    <div class="award-select-shadow" @click="close"></div>
    <div class="award-select-main">
      <a href="javascript:;" class="main-close" @click="close"></a>
      <p class="main-title">{{ letter.chooseRoleGetGift }}</p>
      <div class="main-select">
        <SelectGroup
          icon="selectvh"
          rightSpan="53px"
          class="row-item mb15"
          v-model="serverId"
          @change="selectServer"
        >
          <template slot="option">
            <option value="0" disabled>
              {{ letter.creatework_serverHolder }}
            </option>
            <optgroup :label="letter.yourServer">
              <option
                v-for="item in historyServerList"
                :key="item.ID"
                :value="item.ID"
              >
                {{ item.NAME }}
              </option>
            </optgroup>
            <optgroup :label="letter.allServer">
              <option
                v-for="item in serverList"
                :key="item.ID"
                :value="item.ID"
              >
                {{ item.NAME }}
              </option>
            </optgroup>
          </template>
          <template slot="ico">
            <em class="ico"></em>
          </template>
        </SelectGroup>
        <Select
          icon="selectvh"
          rightSpan="53px"
          class="row-item role-select mb15"
          v-model="roleId"
        >
          <template slot="option">
            <option value="-1" disabled>
              {{ letter.selectRoleName }}
            </option>
            <option
              v-for="item in roleList"
              :key="item.roleID"
              :value="item.roleID"
            >
              {{ item.roleName }}
            </option>
          </template>
          <template slot="ico">
            <em class="ico"></em>
          </template>
        </Select>
      </div>
      <a class="main-bind" href="javascript:;" @click="getAward">
        {{ letter.claim }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  GET_ROLE_LIST_ONLY,
  GET_SERVER_LIST,
  UPDATE_LOADING
} from '@store/officialTopupNew/index';
import {
  clickButton,
  popupType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV35';
export default {
  name: 'AwardRoleSelect',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  data() {
    return {
      serverId: '0',
      roleId: '-1',
      roleList: []
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      stateServerId: state => state.serverId,
      stateRoleId: state => state.roleId,
      serverList: state => state.serverList,
      historyServerList: state => state.historyServerList,
      stateRoleList: state => state.roleList
    }),
    chooseServer() {
      return this.serverList?.find(item => item.ID == this.serverId);
    },
    chooseRole() {
      return this.roleList?.find(item => item.roleID == this.roleId);
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 默认给当前角色
        this.serverId = this.stateServerId || 0;
        this.roleList = this.stateRoleList || [];
        this.roleId = this.stateRoleId || '-1';
        showPopup(popupType.confirmRolePopup);
        if (!this.serverList || this.serverList?.length === 0) {
          this.$store.commit(UPDATE_LOADING, true);
          this.$store.dispatch(GET_SERVER_LIST).then(_serverList => {
            this.$store.commit(UPDATE_LOADING, false);
          });
        }
      }
    },
    roleId(newVal) {
      if (newVal) {
        clickButton({
          btnName: 'switch_role',
          locationKey: popupType.confirmRolePopup
        });
      }
    }
  },
  methods: {
    selectServer() {
      this.roleId = '';
      this.$store.dispatch(GET_ROLE_LIST_ONLY, this.serverId).then(roleList => {
        this.roleList = roleList;
        if (this.roleList.length > 0) {
          this.roleId = this.roleList[0].roleID;
        } else {
          this.roleId = '-1';
        }
      });
    },
    getAward() {
      if (this.serverId && this.roleId) {
        this.$emit('getAward', {
          server_id: this.serverId,
          server_sid: this.chooseServer?.SID,
          server_name: encodeURIComponent(this.chooseServer?.NAME),
          role_id: this.roleId,
          role_name: encodeURIComponent(this.chooseRole?.roleName)
        });
        clickButton({
          btnName: 'confirm_role',
          locationKey: popupType.confirmRolePopup
        });
      }
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';

.award-select {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }

  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 720px;
    height: 500px;
    border-radius: 10px;
  }

  .main {
    &-close {
      position: absolute;
      right: 22px;
      top: 22px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url($commonImg + 'close.png');
      width: 28px;
      height: 28px;
    }

    &-title {
      margin: 64px auto 0px;
      padding: 0 44px;
      font-size: 36px;
      color: var(--popupTitleText, #333);
      text-align: center;
    }

    &-select {
      padding: 30px 64px 22px;
      box-sizing: border-box;

      .row-item {
        display: block;
        position: relative;
        box-sizing: border-box;
        margin: 0 auto 20px;
        width: 602px;
        height: 80px;
        background-size: cover;
        vertical-align: top;
        font-size: 24px;
        color: #333;
        border: 1px solid #d2d2d2;
        border-radius: 10px;

        ::v-deep .select {
          color: #333;
        }

        ::v-deep .ico {
          display: inline-block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: url($commonImg + 'role-ico.png') no-repeat;
          width: 22px;
          height: 13px;
        }
      }
    }

    &-bind {
      font-size: 36px;
      line-height: 70px;
      color: #fff;
      margin: 0px auto 0;
      background: $themeColor;
      width: 610px;
      height: 70px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      cursor: pointer;
    }
  }
}
</style>
